module.exports = __webpack_public_path__ + "img/icon-num3.2763bef9.png";